import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M29.441 0H2.734A2.61 2.61 0 0 0 0 2.492v26.765A2.816 2.816 0 0 0 2.734 32h26.7A2.673 2.673 0 0 0 32 29.257V2.492A2.454 2.454 0 0 0 29.441 0M9.919 26.673H5.335V12.42h4.584Zm-2.134-16.42h-.033a2.353 2.353 0 0 1-2.417-2.459A2.37 2.37 0 0 1 7.81 5.335a2.36 2.36 0 0 1 2.451 2.459 2.367 2.367 0 0 1-2.476 2.459m18.888 16.42h-4.584V18.88c0-1.867-.667-3.142-2.326-3.142a2.51 2.51 0 0 0-2.351 1.692 3.1 3.1 0 0 0-.158 1.125v8.119H12.67V12.42h4.584v1.98a4.64 4.64 0 0 1 4.134-2.317c3.009 0 5.285 1.984 5.285 6.26v8.327Z",
      "data-name": "Icon ionic-logo-linkedin"
    }, null, -1)
  ])))
}
export default { render: render }